import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SelectOption } from '../../../../models/main.model';
import { LegalWarehouseUseOfficial } from '../../../../models/offers.model';

export function usePremisesPurposeOfficialSelectOptions(): SelectOption[] {
  const { t } = useTranslation();
  return useMemo(
    () =>
      Object.entries(LegalWarehouseUseOfficial).map(([, value]) => ({
        label: t(`FORMS.PREMISES_PURPOSE.OPTIONS.${value.toUpperCase()}`),
        value,
      })),
    [t]
  );
}
